<template>
    <div class="d-flex align-items-center">
        <div class="d-flex flex-column">
            <div>
                <slot name="value">
                    <div class="d-flex flex-column">
                        <b-link :to="{ name: 'eventDetail', params: { id: value.id } }">№{{ value.id }}</b-link>
                        <small class="text-secondary">{{ value['kind_name'] }}</small>
                        <small class="text-secondary">{{ value['owner_type'] }}</small>
                    </div>
                </slot>
            </div>
            <div>
                <slot name="secondary">
                </slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "EventInfoCell",
    props: {
        value: {},
    },
}
</script>

<style scoped>

</style>